import { render, staticRenderFns } from "./AiView.vue?vue&type=template&id=c9210ec2"
import script from "./AiView.vue?vue&type=script&lang=js"
export * from "./AiView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports